import { CoverageInputDeductible, SectionHeader } from '@insify/funnel-components';

import { useContent } from '../../../../hooks/useContent';
import { useCoverageOptions } from '../../userCoverageOptions';

import * as styles from './DeductibleInput.module.css';

type Props = {
  className?: string;
};

export const DeductibleInput: React.FC<Props> = () => {
  const { coverageDeductible } = useContent() || {};
  const { deductibleOptions } = useCoverageOptions();
  return (
    <div>
      <SectionHeader>
        <SectionHeader.Content content={coverageDeductible} />
      </SectionHeader>
      <CoverageInputDeductible className={styles.input} options={deductibleOptions} />
    </div>
  );
};
